export default __webpack_public_path__ + "static/media/IGNACIO LOPEZ ARAMBURU.8ac81e60.jpg";